import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Collapse } from "react-bootstrap";
import { IoFunnel } from "react-icons/io5";

import HeaderWrapper from "../common/HeaderWrapper";
import DepartmentCategoryList from "./DepartmentCategoryList";
import * as departmentCategoryActions from "../../actions/departmentCategoryActions";
import * as modalActions from "../../actions/modalActions";
import * as departmentActions from "../../actions/departmentActions";
import DepartmentCategoryForm from "./DepartmentCategoryForm";
import Modal from "../common/Modal";

import DepartmentCategoryFilters from "./DepartmentCategoryFilters";

const DepartmentCategoryPage = ({
  departmentCategories,
  actions,
  departmentCategory,
  departments,
  loading
}) => {
  const [formOpened, setFormOpened] = useState(false);
  const [filters, setFilters] = useState({ department: [], status: null });
  const [filtersOpen, setFiltersOpen] = useState(false);

  const onClickAdd = () => {
    setFormOpened((prev) => !prev);
  };

  const onClickEdit = (id) => {
    actions.getDepartmentCategory(id, true);
  };

  useEffect(() => {
    if (!departments?.length) {
      actions.loadDepartments();
    }
  }, [actions, departments]);

  useEffect(() => {
    actions.loadDepartmentCategories(filters);
  }, [filters, actions]);

  const handleAdd = async (values) => {
    setFormOpened(false);
    await actions.createDepartmentCategory(values);
    actions.loadDepartmentCategories(filters);
  };

  const handleEdit = async (values) => {
    await actions.updateDepartmentCategory(values);
    actions.loadDepartmentCategories(filters);
  };

  const handleFiltersChange = (name, value) => {
    setFilters((prev) => ({ ...prev, [name]: value }));
  };

  const handleFiltersReset = () => {
    setFilters({ department: [], status: null });
  };

  const addDepartmentCategoryForm = (
    <DepartmentCategoryForm
      adding
      departments={departments}
      onCancel={() => setFormOpened(false)}
      onSave={handleAdd}
    />
  );

  const editDepartmentCategoryForm = (
    <DepartmentCategoryForm
      departmentCategory={departmentCategory}
      departments={departments}
      onCancel={() => actions.hideModal("departmentCategoryModal")}
      onSave={handleEdit}
    />
  );

  return (
    <React.Fragment>
      <HeaderWrapper
        breadcrumbs={[
          { label: "Settings" },
          { label: "Department Categories" }
        ]}
        onClickAdd={onClickAdd}
        onClickAction={[
          { action: () => setFiltersOpen(!filtersOpen), icon: <IoFunnel /> }
        ]}
      />
      <DepartmentCategoryFilters
        filters={filters}
        onChange={handleFiltersChange}
        onReset={handleFiltersReset}
        open={filtersOpen}
        loading={loading}
      />
      <div>
        <Collapse in={formOpened}>
          <div>
            <div className="content-wrapper">
              <h4>Add Department Category</h4>
              {addDepartmentCategoryForm}
            </div>
          </div>
        </Collapse>
      </div>
      <div className="content-wrapper">
        <DepartmentCategoryList
          departmentCategories={departmentCategories}
          onClickEdit={onClickEdit}
          loading={loading}
        />
        <Modal
          id="departmentCategoryModal"
          title="Department Category"
          body={editDepartmentCategoryForm}
          close={() => actions.hideModal("departmentCategoryModal")}
        />
      </div>
    </React.Fragment>
  );
};

DepartmentCategoryPage.propTypes = {
  actions: PropTypes.object,
  departmentCategories: PropTypes.array.isRequired,
  departmentCategory: PropTypes.object,
  departments: PropTypes.array,
  loading: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    departmentCategories: state.reducers.departmentCategories,
    departmentCategory: state.reducers.departmentCategory,
    departments: state.reducers.departments,
    loading: state.reducers.loading
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { ...departmentCategoryActions, ...modalActions, ...departmentActions },
      dispatch
    )
  };
}

export default connect(
  mapStatesToProps,
  mapDispatchToProps
)(DepartmentCategoryPage);
